import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  IconButton,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  CircularProgress,
  Grid,
  DialogTitle as MuiDialogTitle,
  DialogContent,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import useStyles from "../../styles";
import AddIcon from "@material-ui/icons/Add";
//store
import * as actions from "../../../../store/actions/actionIndex";
import { notify, decryptPhoneNumber  } from "../../../../helpers/utility";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    insetInlineEnd: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function AddCustomerDialog(props) {
  var classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [list, setList] = React.useState("");
  const [callType, setCallType] = useState("")
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const addCustomer = () => {
    if (list === "") {
      notify("List Error - Please select a list", "list-error");
      return;
    }
    console.log(list)
    props.onCreateCustomer(props.agentId, decryptPhoneNumber(props.custPhone), list, callType);
    setTimeout(() => {
      props.onGetDisposition(props.agentId);
    }, 1000);
  };

  useEffect(() =>{
 setCallType(props.callType)
  },[props.callType])
  return (
    <div style={{ padding: "10px 0" }}>
      <Grid container spacing={1}>
        <Grid item xs={6} sm={3}>
          {/*<Card onClick={handleClickOpen} style={{ border: "1px solid blue", borderStyle: "double" }}>
						<CardActionArea className={classes.AddCallActionArea}>
							<AddCallIcon />
							<Typography className={classes.AddMemberText} color="textSecondary">
								ADD CUSTOMER
							</Typography>
						</CardActionArea>
					</Card>*/}
          <Button
            variant="outlined"
            color="primary"
            size="small"
            style={{
              textTransform: "capitalize",
              border: "2px solid",
              marginInlineStart: "0",
              marginInlineEnd: "10px",
            }}
            className={classes.ConferenceButton}
            onClick={handleClickOpen}
          >
            <AddIcon />
            &nbsp; Add Customer
          </Button>
        </Grid>
      </Grid>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add Customer
        </DialogTitle>
        <DialogContent>
          <div>
            <FormControl variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                Select List
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Select List"
                style={{ width: "250px" }}
                value={list}
                onChange={(e) => setList(e.target.value)}
              >
                {Object.keys(props.activeLists).map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {props.activeLists[item]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              autoFocus
              color="primary"
              style={{ border: "1px solid" }}
              onClick={addCustomer}
            >
              Add Customer
              {props.loading ? (
                <CircularProgress
                  size={18}
                  style={{ verticalAlign: "middle" }}
                />
              ) : (
                ""
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.customerDetails.loading,
    activeLeadId: state.customerDetails.leadId,
    custPhone: state.agentData.custPhone,
    leadId: state.agentData.leadId,
    agentState: state.agentData.agentState,
    callType: state.agentData.callType,
    activeLists: state.agentConfig.activeLists,
    facilityConf: state.agentConfig.facilityConf,
    campConf: state.agentConfig.campConf,
    agentId: state.agentData.agentId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateCustomer: (agentId, custPhone, listId, callType) =>
      dispatch(actions.createCustomer(agentId, custPhone, listId, callType)),
     onGetDisposition: (agentId) => dispatch(actions.getDisposition(agentId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomerDialog);
